"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdministrativeInfo = exports.AdministrativeDocument = exports.AdministrativeDocumentType = void 0;
const infrastructure_1 = require("../../../infrastructure");
const validator_1 = require("@leavy/validator");
const utils_1 = require("@leavy/utils");
var AdministrativeDocumentType;
(function (AdministrativeDocumentType) {
    AdministrativeDocumentType["FLAT_ADDRESS_PROOF"] = "FLAT_ADDRESS_PROOF";
    AdministrativeDocumentType["OTHER"] = "OTHER";
})(AdministrativeDocumentType = exports.AdministrativeDocumentType || (exports.AdministrativeDocumentType = {}));
class AdministrativeDocument extends infrastructure_1.ValueObjectBase {
    constructor(data) {
        super();
        this.initialize(data);
    }
    isComplete() {
        return (utils_1.Guard.isNotNullish(this.fileId) && utils_1.Guard.String.isNotEmpty(this.fileId)
            && utils_1.Guard.isNotNullish(this.documentType) && utils_1.Guard.Enum.isEnumMember(AdministrativeDocumentType)(this.documentType));
    }
    toPlain() {
        return { ...this };
    }
}
exports.AdministrativeDocument = AdministrativeDocument;
class AdministrativeInfo extends infrastructure_1.ValueObjectBase {
    constructor(data) {
        super();
        this.documents = [];
        this.initialize(data);
    }
    isComplete() {
        return (this.documents.some(x => x.documentType == AdministrativeDocumentType.FLAT_ADDRESS_PROOF)
            && this.documents.every(x => x.isComplete()));
    }
    toPlain() {
        return { ...this };
    }
}
__decorate([
    (0, validator_1.Type)(() => AdministrativeDocument),
    __metadata("design:type", Array)
], AdministrativeInfo.prototype, "documents", void 0);
exports.AdministrativeInfo = AdministrativeInfo;
//# sourceMappingURL=AdministrativeInfo.js.map